<template lang="pug">
    b-container.page-container
      h1 Payment received
      p Your order will be updated shortly!
      router-link(:to="{name: 'orderPage'}")
        i.fa.fa-caret-left.mr-2
        span Return to orders
</template>

<script>
export default {
  name: 'PaymentSuccess',
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PaymentSuccess.vue